interface Headers {
    [name: string]: string;
}

interface HttpRejection {
    message: string,
    responseText: string;
    status: number;
}

function createRejection(xhr: XMLHttpRequest, message: string): HttpRejection {
    return {
        status: xhr.status,
        responseText: xhr.responseText,
        message
    }
}

type DataType = string | Document | Blob | ArrayBufferView | ArrayBuffer | FormData | URLSearchParams | ReadableStream<Uint8Array>;

interface Options {
    url: string;
    method: string;
    headers?: Headers;
    data?: DataType;
}

function http(options: Options): Promise<string> {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    resolve(xhr.responseText)
                } else {
                    reject(
                        createRejection(xhr, '[http_post]: Received non-OK status (' + xhr.status + ') for GET ' + options.url)
                    );
                }
            }
        };

        xhr.open(options.method, options.url, true);

        if (options.headers) {
            for (const header in options.headers) {
                if (options.headers.hasOwnProperty(header)) {
                    xhr.setRequestHeader(header, options.headers[header]);
                }
            }
        }

        xhr.send(options.data);
    });
}

export function http_get(url: string, headers: Headers = {}): Promise<string> {
    return http({
        url,
        headers,
        method: 'GET'
    });
}

export function http_post(url: string, data: DataType, headers: Headers = {}): Promise<string> {
    return http({
        url,
        headers,
        method: 'POST',
        data: data
    });
}